import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Select, Input, Table, notification, Dropdown } from "antd";
import { FilePdfOutlined, MailOutlined } from "@ant-design/icons";
import moment from "moment";

import { NavigationPath } from "../../../helpers/constants";
import ActionButtons from "../../ActionButtons/ActionButtons";
import ExportIcon from "../../../images/Export.svg";
import styles from "../Ponude.module.scss";
import OfferDetailsModal from "../OfferDetailsModal";
import SendEmailModal from "../SendEmailModal";
const { Search } = Input;

const PonudeLeasingAdmin = ({ offerState, actions }) => {
  const { offers, suppliers, years } = offerState;

  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, msg) => {
    api[type]({
      message: msg,
    });
  };
  const [searchDobavljac, setSearchDobavljac] = useState(null);
  const [searchYear, setSearchYear] = useState(null);
  const [searchUser, setSearchUser] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [currentOffer, setCurrentOffer] = useState(null);
  const [posaljiPonudu, setPosaljiPonudu] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);

  useEffect(() => {
    actions.getOffers();
    actions.getSuppliers();
    actions.getYearsForOffers();
  }, []);

  const getSupplierName = (supplierId) => {
    const result = suppliers?.find(({ key }) => supplierId === key);
    return result?.kompanija;
  };

  const supplierSelectOptions = suppliers?.map((supplier) => ({
    value: supplier.key,
    label: supplier.kompanija,
  }));

  const yearsSelectOptions = years?.map((year) => ({
    value: year.year,
    label: year.year,
  }));

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      width: 50,
    },
    {
      title: "Broj ponude",
      dataIndex: "broj",
      width: 90,
    },
    {
      title: "Datum ponude",
      dataIndex: "datum",
      sorter: (a, b) => new Date(a.datum) - new Date(b.datum),

      width: 110,
    },
    {
      title: "Naziv kupca",
      dataIndex: "kupac",
    },
    {
      title: "Vrsta kupca",
      dataIndex: "vrsta",
      width: 120,
    },
    {
      title: "Ime i prezime",
      dataIndex: "imeprezime",
      filteredValue: [searchUser],
      onFilter: (value, record) => {
        return record.imeprezime.toLowerCase().includes(value.toLowerCase());
      },
      render: (text) => <a className="text-light-blue">{text}</a>,
    },
    {
      title: "Dobavljač",
      dataIndex: "dobavljac",
      sorter: (a, b) => a.dobavljac.localeCompare(b.dobavljac),
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedUser(selectedRows);
    },
  };

  const navigateToWebCalculator = () => {
    navigate(NavigationPath.WEB_CALCULATOR_ROUTE);
  };

  const navigateToEdit = () => {
    if (selectedUser?.length === 1) {
      navigate(`/offer/${selectedUser[0].broj}`);
    } else {
      openNotificationWithIcon("warning", "Select one offer to edit");
    }
  };

  const handleDeleteUser = () => {
    if (selectedUser) {
      const offerIds = selectedUser.map((offer) => offer.key);
      actions.deleteOffer(offerIds);
      setSelectedUser(null);
    }
  };

  const filterByDobavljac = (filterValue) => {
    if (!filterValue) {
      return;
    }
    setSearchDobavljac(filterValue);
    actions.getOffers(filterValue, searchYear);
  };

  const filterByYear = (filterValue) => {
    if (!filterValue) {
      return;
    }
    setSearchYear(filterValue);
    actions.getOffers(searchDobavljac, filterValue);
  };

  const exportIconItems = [
    {
      label: "Detalji",
      key: "detalji",
    },
    {
      label: "PDF",
      key: "pdf",
      icon: <FilePdfOutlined />,
    },
  ];

  const onClickActions = ({ key }, offer) => {
    if (key === "detalji") {
      console.log(offer);
      setDetailsModal(true);
    } else {
      actions.generatePdf(offer.offerNumber);
    }
  };

  const renderActions = (offer) => (
    <div className="flex gap-2 ">
      <Dropdown
        trigger={["click"]}
        menu={{
          items: exportIconItems,
          onClick: (e) => onClickActions(e, offer),
        }}
      >
        <img
          className="h-[14px] cursor-pointer"
          src={ExportIcon}
          onClick={(e) => {
            e.preventDefault();
            setCurrentOffer(offer);
          }}
        />
      </Dropdown>

      <MailOutlined
        className="cursor-pointer"
        onClick={() => {
          setPosaljiPonudu(true);
          setCurrentOffer(offer);
        }}
      />
    </div>
  );

  return (
    <div className="px-8 py-4">
      {contextHolder}
      <Flex justify="space-between" className="mb-4">
        <ActionButtons
          navigateToAdd={navigateToWebCalculator}
          navigateToEdit={navigateToEdit}
          handleDelete={handleDeleteUser}
          selectedUser={selectedUser}
        />

        <Flex>
          <Select
            defaultValue="Godina"
            bordered={false}
            options={yearsSelectOptions}
            onChange={(e) => filterByYear(e)}
            className="max-w-[210px]"
          />
          <Select
            defaultValue="Dobavljač"
            bordered={false}
            options={supplierSelectOptions}
            onChange={(e) => filterByDobavljac(e)}
            className="max-w-[210px]"
          />
          <Search
            className="bg-light-blue rounded-l-md rounded-r-sm w-80"
            placeholder="Traži po imenu / prezimenu korisnika"
            onSearch={(value) => setSearchUser(value)}
            enterButton
          />
        </Flex>
      </Flex>
      <Table
        className={styles.table}
        columns={columns}
        dataSource={offers?.map((offer) => ({
          key: offer.id,
          actions: renderActions(offer),
          broj: offer.offerNumber,
          datum: moment(offer.createdAt).format("YYYY-MM-DD"),
          kupac: offer.companyName,
          vrsta: offer.clientType,
          imeprezime: offer.createdBy,
          dobavljac: getSupplierName(offer.supplierId),
        }))}
        rowSelection={{
          ...rowSelection,
        }}
        // onChange={onChange}
      />
      {detailsModal && (
        <OfferDetailsModal
          detailsModal={detailsModal}
          setDetailsModal={setDetailsModal}
          currentOffer={currentOffer}
        />
      )}
      {posaljiPonudu && (
        <SendEmailModal
          posaljiPonudu={posaljiPonudu}
          setPosaljiPonudu={setPosaljiPonudu}
          offer={currentOffer}
          actions={actions}
        />
      )}
    </div>
  );
};

export default PonudeLeasingAdmin;
